import { z } from "zod";

export const SearchSchema = z.object({
  personId: z.string().optional(),
});

export type SearchParams = z.infer<typeof SearchSchema>;
